<template>
  <div class="state-display-container">
    <div v-if="error">
      <h1 class="state-display-message">{{ errorMessage }}</h1>
    </div>
    <template v-else-if="loading">
      <div class="loader-container" v-if="loading">
        <div class="loader">
          <span class="loader__dot" />
          <span class="loader__dot" />
          <span class="loader__dot" />
        </div>
      </div>
      <div class="state-display-loading">{{ loadingMessage }}</div>
    </template>
    <div v-else-if="noResults">
      <h1 class="state-display-message">{{ noResultsMessage }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "StateDisplay",
  props: {
    loading: {
      type: Boolean,
    },
    loadingMessage: {
      default: "Loading...",
    },
    noResults: {
      type: Boolean,
    },
    noResultsMessage: {
      default: "No Results",
    },
    error: {
      type: Boolean,
    },
    errorMessage: {
      default: "There was an Error",
    },
  },
};
</script>

<style lang="scss" scoped>
.state-display-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
}

.state-display-message {
  color: #9f9f9f;
}

.state-display-loading {
  margin-top: 18px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: rgba(0, 0, 0, 0.45);
  animation: loadingFade 1.6s ease-in-out infinite;
}

.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Drei sanft springende Punkte im Lila-Akzent */
.loader {
  display: flex;
  align-items: center;
  gap: 8px;

  &__dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #7b5cd6;
    animation: loadingBounce 1.2s ease-in-out infinite;

    &:nth-child(2) {
      animation-delay: 0.15s;
      opacity: 0.75;
    }
    &:nth-child(3) {
      animation-delay: 0.3s;
      opacity: 0.5;
    }
  }
}

@keyframes loadingBounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-10px);
  }
}

@keyframes loadingFade {
  0%,
  100% {
    opacity: 0.55;
  }
  50% {
    opacity: 1;
  }
}

</style>
